<template>
  <v-sheet
    ref="sheet"
    :height="height"
    class="overflow-y-auto"
  >
    <div v-if="chatDatasLoading"></div>
    <div v-else-if="chats.length===0">
      <alert>Не найдено</alert>
    </div>
    <v-list v-else dense class="pa-0">
      <v-list-item
          v-for="d in chats" :key="d.id"
          @click="localSelectChat=d"
          class="pa-0"
          :class="(localSelectChat?.id===d.id ? 'v-list-item--active' : '')+(d.blink===true ? ' blinkWarning' : '')"
      >
        <v-row no-gutters class="full-width">
          <v-col class="pa-3">
            <v-row no-gutters>
              <v-col>{{d.name}}</v-col>
              <v-col cols="auto" class="caption">{{d.dialogMesLast==null ? '' : $tools.dateFormat(d.dialogMesLast.created, true)}}</v-col>
            </v-row>
            <v-row no-gutters align="center">
              <v-col style="flex:1" class="body-2 text-no-wrap overflow-hidden text-overflow muted1">
                <span v-if="d.dialogMesLast===null" class="body-2 text-no-wrap overflow-hidden muted">
                  Нет сообщений
                </span>
                <span v-else>
                  <span v-if="d.dialogMesLast.dialogUser.user!==null && d.dialogMesLast.dialogUser.user?.type!=='client'">
                    {{$tools.userFullName(d.dialogMesLast.dialogUser.user, true)}}:
                  </span>
                  <span style="flex:1">{{d.dialogMesLast.text}}</span>
                  <span v-if="d.dialogMesLast.dialogMessageAttachs.length>0">(Вложение)</span>
                </span>
              </v-col>
              <v-col cols="auto" class="pl-2">
                <v-sheet v-if="d._unreadCount>0" width="20" height="20" color="transparent">
                  <v-avatar size="20" color="primary" class="caption white--text position-absolute">
                    {{d._unreadCount}}
                  </v-avatar>
                </v-sheet>
              </v-col>
            </v-row>
            <chip v-if="filterView?.id==='all' && !$tools.isEmpty(d.userOperator)" class="mt-1" small>Оператор: {{$tools.userFullName(d.userOperator, true)}}</chip>
          </v-col>
          <v-col cols="12">
            <v-divider/>
          </v-col>
        </v-row>
      </v-list-item>
    </v-list>
    <!--<progress-page v-if="page>1 && chatsState.data.count>chatsState.data.items.length"/>-->
  </v-sheet>
</template>

<script>
import Alert from "@/componentsV2/base/Alert.vue";
import Chip from "@/componentsV2/base/Chip.vue";
import axios from "axios";

export default {
  components: {Chip, Alert},
  props: ['height','cat','search','filterView','selectChat'],
  data: () => ({
    chatDatas:[],
    chats:[],
    chatDatasLoading:false,
    localSelectChat:null,
    subscribeListenerId:null,
  }),
  mounted() {
    this.localSelectChat = this.selectChat;
    this.load();
    this.$ws.connectWithSubscribeListener(this.$store.state.user, (v)=>this.subscribeListenerId=v, (m)=>{
      if(m.type==='dialogChat') this.addChatData(m.data, true);
    });
    //this.$refs.sheet.$el.addEventListener('scroll',this.scrollHandler);
  },
  watch:{
    //chats(){this.chats = this.chatsFilter(this.chats, this.cat)},
    filterView(){this.chatsFilter()},
    search(){this.load()},
    selectChat(){this.localSelectChat = this.selectChat},
    localSelectChat(){this.$emit('update:selectChat', this.localSelectChat)},
  },
  beforeDestroy() {
    this.$ws.removeSubscribeListener(this.subscribeListenerId);
    //this.$refs.sheet.$el.removeEventListener('scroll',this.scrollHandler);
  },
  methods:{
    load() {
      this.chatDatas = [];
      this.$emit('loading', true);
      this.chatDatasLoading = true;
      axios.get('/napi/dialog/chat/?cat='+this.cat.id+(this.$tools.isEmpty(this.search) ? '' : '&q='+this.search))
          .then(r => {
            r.data.forEach(v=> this.addChatData(v))
            this.$emit('loading', false);
            this.chatDatasLoading = false;
          });
    },
    addChatData(data, isEvent = false){
      if(this.cat.id!==data.cat) return;

      const index = this.chatDatas.findIndex(v => v.id === data.id);
      data.blink = isEvent;

      if(index===-1) this.chatDatas.push(data);
      else this.chatDatas[index] = data;

      if(isEvent)
        setTimeout(()=>{
          const index = this.chatDatas.findIndex(v => v.id === data.id);
          if(index!==-1){
            this.chatDatas[index].blink = false;
            this.chatsFilter();
          }
        }, 2000)

      this.chatsFilter();
    },
    chatsFilter() {
      if (
          (this.cat.id === 'process' || this.cat.id === 'closed') &&
          this.filterView?.id === 'my'
      ) {
        this.chats = this.chatDatas.filter(chat => {
          let found = false;
          chat.dialogUsers.forEach(dialogUser => {
            if (dialogUser.user?.id === this.user?.id)
              found = true;
          })
          return found;
        });
      } else {
        this.chats = this.chatDatas;
      }

      this.chatsSort();
    },

    chatsSort() {
      this.chats = this.chats.sort((a, b)=>{
        let a1 = a.dialogMesLast ? 10000+a.dialogMesLast.id : + a.id;
        let b1 = b.dialogMesLast ? 10000+b.dialogMesLast.id : + b.id;
        if(a1===b1) return 0;
        return a1>b1 ? -1 : 1;
      })

      this.$emit('unreadCount', this.chats.filter(chat=>chat.cat===this.cat.id && chat._unreadCount>0).length);
    },

    /*
    scrollHandler(){
      const el = this.$refs.sheet.$el;
      if(el.scrollTop + el.clientHeight >= el.scrollHeight-100 && this.chatsState.data.count>this.chatsState.data.items.length){
        this.$emit('loadMore', ++this.page)
      }
    }

     */
  }
}
</script>